import { isUserLoggedInSelector, useTokenStore } from '@ping/stores/token.store';
import { isUserDataExistSelector, useUserInformationStore } from '@ping/stores/userInformation.store';

export const useIsUserLoggedIn = () => {
  const hasToken = useTokenStore(isUserLoggedInSelector);
  const hasUserData = useUserInformationStore(isUserDataExistSelector);

  return hasToken && hasUserData;
};
